module.exports = __webpack_public_path__ + "img/06.9ad2020b.jpg";